import React from "react";
import { Col, Card, Button, ButtonGroup } from "react-bootstrap";
import {
  MdEdit,
  MdDone,
  MdOutlinePix,
  MdLockPerson,
  MdOutlineSpeakerNotes,
  MdOutlineImportContacts
} from "react-icons/md";
import { createOng } from "../../../../store/register/ong/actions"
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"

import Step1 from "../step_1/index";
import Step2 from "../step_2/index";
import Step3 from "../step_3/index";
import Step4 from "../step_4/index";
import SuccessStep from "../../common/success-step/index";
import Alerts from "./../../common/alerts/index"
import "../../custom.css";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current_step: 0, //@to-do remove, default 0
      is_linkt: true,
      codigoReferencia: 'Linkt-sigmobi',
      form: JSON.parse(localStorage.getItem('form')) || {}
    };
  }

  componentDidMount() {
    const { code } = this.props.match.params
    if (code) {
      this.setState({ codigoReferencia: code, form: { referral_code: code }, is_linkt: false });
    }
    if (this.props.success) {
      return this.setState({ current_step: 4 })
    }
  }

  mainSetState = (state) => {
    this.setState(state)
    return this.state
  }

  callBackStatusCreate = async () => {
    this.setState({ current_step: 5 })
  }

  submitForm = async (data) => {
    data.referral_code = this.state.is_linkt ? this.state.codigoReferencia : data.referral_code
    await this.props.createOng(data, this.callBackStatusCreate)
  }

  upateForm = (data = {}) => {
    const form = { ...this.state.form, ...data }
    localStorage.setItem('form', JSON.stringify(form))
    this.setState({ form, current_step: 0 })
  }

  back = () => {
    const { current_step } = this.state;
    if (current_step <= 4) {
      this.setState({ current_step: 0 });
    }
  }

  nextStep = () => {
    const { current_step } = this.state;
    if (current_step <= 5) {
      this.setState({ current_step: current_step + 1 });
    }
    this.setState({ form: JSON.parse(localStorage.getItem('form')) || {} })
  };

  renderStep = () => {
    const { current_step } = this.state;

    const stepsMap = {
      1: <Step1 back={this.back} submit={this.upateForm} form={this.state.form} />,
      2: <Step2 back={this.back} hidden_ref_code={this.state.is_linkt} submit={this.upateForm} form={this.state.form} />,
      3: <Step3 back={this.back} submit={this.upateForm} form={this.state.form} />,
      4: <Step4 back={this.back} submit={this.upateForm} form={this.state.form} />,
      5: <SuccessStep mainSetState={this.mainSetState} type_form={3} />,
    };

    return stepsMap[current_step] || null;
  };

  getCheckSteps = () => {
    return [
      //step 0 picture
      true, //[this.state.form?.picture].every(v => v),
      //step 1
      [
        this.state.form?.corporate_name,
        this.state.form?.document,
        this.state.form?.trade_name,
        this.state.form?.phone
      ].every(v => v),
      //step 2
      [
        this.state.form?.email,
        this.state.form?.password,
        this.state.form?.confirm_password
      ].every(v => v),
      //step 3
      [
        this.state.form?.pix_key,
        this.state.form?.pix_key_type
      ].every(v => v),
      //step 4
      [this.state.form?.term_of_use].every(v => v)
    ]
  }

  isCheckedForm = () => {
    return this.getCheckSteps().every(v => v)
  }

  iScheckedStep = (step = 0) => {
    return this.getCheckSteps()[step] || false
  }

  render() {
    const { current_step } = this.state;

    return (
      <React.Fragment>
        {current_step === 0 &&
          (
            <div className="container-menu">
              <div className="background"></div>

              <Col className="col-12 col-md-4 col-lg-4">
                {/* <img src="https://cdn.sigmobi.com/lpimg/ic_logo_top_flyer.png" /> */}

                <h1>Cadastro de ONG</h1>
                <p className="mb-5">Preencha os dados abaixo para se cadastrar.</p>

                <Card>
                  <Card.Body>
                    <Card.Title><MdOutlineSpeakerNotes /> Informações da Empresa</Card.Title>
                    {/* <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle> */}
                    <Button
                      onClick={() => this.setState({ current_step: 1 })}
                      className={this.iScheckedStep(1) ? 'btn-success' : 'btn-light'}
                    >
                      {this.iScheckedStep(1) ? <MdDone /> : <MdEdit />}
                    </Button>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body>
                    <Card.Title><MdLockPerson /> Acesso</Card.Title>
                    {/* <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle> */}
                    <Button
                      onClick={() => this.setState({ current_step: 2 })}
                      className={this.iScheckedStep(2) ? 'btn-success' : 'btn-primary'}
                    >
                      {this.iScheckedStep(2) ? <MdDone /> : <MdEdit />}
                    </Button>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Body>
                    <Card.Title><MdOutlinePix /> Chave PIX</Card.Title>
                    <Button
                      onClick={() => this.setState({ current_step: 3 })}
                      className={this.iScheckedStep(3) ? 'btn-success' : 'btn-primary'}
                    >
                      {this.iScheckedStep(3) ? <MdDone /> : <MdEdit />}
                    </Button>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Body>
                    <Card.Title><MdOutlineImportContacts />Termos e Condições de Uso </Card.Title>
                    <Button
                      onClick={() => this.setState({ current_step: 4 })}
                      className={this.iScheckedStep(4) ? 'btn-success' : 'btn-primary'}
                    >
                      {this.iScheckedStep(4) ? <MdDone /> : <MdEdit />}
                    </Button>
                  </Card.Body>
                </Card>

                <Alerts mainSetState={this.mainSetState} lastStep={5} />

                {this.isCheckedForm() &&<ButtonGroup className="offset-2 col-8 col-md-6 offset-md-3 col-lg-4 offset-lg-4 mt-3">
                  <Button
                    onClick={() => this.submitForm(this.state.form)}
                    className="btn btn-primary btn-large centerButton"
                    type="button"
                  >Enviar</Button>
                </ButtonGroup>}
              </Col>
            </div>
          )}

        <div className="container-steps">
          {this.renderStep() && (
            <>
              {this.renderStep()}
            </>
          )}
        </div>

      </React.Fragment>
    );
  }
}

Main.PropTypes = {
  t: PropTypes.any,
  history: PropTypes.any,
  loading: PropTypes.any,
  error: PropTypes.any,
  message: PropTypes.any,
  id: PropTypes.any,
}

const mapStateToProps = state => {
  const success = [
    state.Ong?.success || false,
    state.Provider?.success || false,
    state.Passager?.success || false
  ].some(v => v)

  const type = [
    state.Ong?.success ? state.Ong.formType : null,
    state.Provider?.success ? state.Ong.formType : null,
    state.Passager?.success ? state.Ong.formType : null,
  ].filter(v => v)[0] || 'passager'

  return {
    ...state.Ong,
    success: success,
    type: type
  }
}
export default withTranslation()(withRouter(connect(mapStateToProps, {
  createOng
})(
  (Main)
)))


